export enum FileStatusEnum {
	pending = 'pending',
	processing = 'processing',
	queue_error = 'queue-error',
	error = 'error',
	success = 'success',
}
